module.exports = __webpack_public_path__ + "img/icon_phone.2e9e5271.svg";